<template>
    <div class="dot-navigation-container flex items-center" :class="{'primary-color': primaryColor}">
        <div class="left-arrow" @click="prevPage">
            <img :src="primaryColor ? '/imgs/icons/left-primary-arrow.webp' : '/imgs/icons/left-white-arrow.webp'" v-show="value > 1">
        </div>
        <div class="flex-grow" />
        <div class="dot-navigation">
            <div v-for="i in pageCount" :key="i" @click="$emit('input' ,i)" :class="{active: i === value}" />
        </div>
        <div class="flex-grow" />
        <div class="right-arrow" @click="nextPage">
            <img :src="primaryColor ? '/imgs/icons/right-primary-arrow.webp' : '/imgs/icons/right-white-arrow.webp'" v-show="value < pageCount">
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: Number,
        pageCount: Number,
        primaryColor: Boolean,
    },

    methods: {
        prevPage() {
            if (this.value > 1) {
                this.$emit('input', this.value - 1);
            } else {
                this.$emit('input', this.pageCount);
            }
        },
        nextPage() {
            if (this.value < this.pageCount) {
                this.$emit('input', this.value + 1);
            } else {
                this.$emit('input', 1);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.dot-navigation-container {
    display: flex;
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    .dot-navigation {
        display: flex;
        align-items: center;
        justify-content: center;
        > div {
            width: 10px;
            height: 10px;
            margin: 0 10px;
            border-radius: 5px;
            background-color: #FFFFFF88;
            transition: width 300ms, background-color 300ms;
            &.active {
                background-color: #FFFFFF;
                width: 30px;
            }
        }
    }
    .left-arrow, .right-arrow {
        width: 22px;
        height: 22px;
    }
    &.primary-color {
        .dot-navigation {
            > div {
                background-color: #00A07F88;
                &.active {
                    background-color: #00A07F;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/DotNavigation.vue